const eur = new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" });

export const formatPrice = (value) => (typeof value === "number" ? eur.format(value) : "Preço a confirmar");

export const AVAILABILITY = {
  stock: { label: "Em stock", tone: "text-[#3F5639]" },
  encomenda: { label: "Feito por encomenda", tone: "text-bordeaux" },
  "a-confirmar": { label: "Disponibilidade a confirmar", tone: "text-taupe-strong" },
};

export const availabilityOf = (product) => AVAILABILITY[product?.availability?.type] ?? AVAILABILITY["a-confirmar"];
